import { isEmpty } from 'lodash';
import { DESTINATION_TYPES } from '../../consts/tickets';

export const serializeTourSelection = form => {
  let dates = null;
  let destinationType = null;
  let destinationId = null;

  if (!isEmpty(form.departure_dates)) {
    const dateFrom = new Date(form.departure_dates[0]);
    const dateTo = new Date(form.departure_dates[1]);
    dates = [dateFrom, dateTo];
  }

  if (form.destination) {
    [destinationType, destinationId] = form.destination.split('_');
  }

  return {
    adults: form.adults,
    cityFromId: form.departure_city_id,
    dates,
    destination: form.destination && {
      id: destinationId,
      isHotel: destinationType === DESTINATION_TYPES.HOTEL,
      label: form.destination_name,
      value: form.destination,
    },
    isNightsFlex: form.flex_nights,
    kids: form.kids,
    nights: form.nights,
    hotelMealId: form.meals && form.meals[0], // TODO: Will remove after add multi select
    price: form.budget,
    sourceId: form.source_id,
    segmentId: form.segment_id,
    comment: form.comment,
    partnerId: form.partner_ids && form.partner_ids[0], // TODO: Will remove after add multi select
  };
};
